import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 

// ---------------
 
interface CheckoutState {
  session: any,
  freeTrialDays: number; 
  quantity: number; 
  taxes: any; 
  subtotal: string; 
  total: string; 
}

// ---------------

const initialState: CheckoutState = {
  session: null, 
  freeTrialDays: 0, 
  quantity: 0, 
  taxes: null, 
  subtotal: '', 
  total: '', 
};

// ---------------


export const checkoutSlice = createSlice({

  name: 'checkout',

  initialState,

  reducers: {

    setSession: (state, action: PayloadAction<any>) => { 

        state.session = action.payload; 

    },
    setFreeTrialDays: (state, action: PayloadAction<number>) => { 

        state.freeTrialDays = action.payload; 

    },
    setQuantity: (state, action: PayloadAction<number>) => { 

        state.quantity = action.payload; 

    }, 
    setTaxes: (state, action: PayloadAction<number>) => { 

        state.taxes = action.payload; 

    },
    setSubtotal: (state, action: PayloadAction<string>) => { 

        state.subtotal = action.payload; 

    },
    setTotal: (state, action: PayloadAction<string>) => { 

        state.total = action.payload; 

    },
    resetCheckout: (state) => { 
        
      state.session = null; 
      state.freeTrialDays = 0; 
      state.quantity = 0; 
      state.taxes = null; 
      state.subtotal = ''; 
      state.total = ''; 

    } 

  },

}); 

// ---------------

export const { 
  setSession, 
  setFreeTrialDays, 
  setQuantity, 
  setTaxes, 
  setSubtotal, 
  setTotal, 
  resetCheckout 
} = checkoutSlice.actions;

export default checkoutSlice.reducer;